import styled from 'styled-components/macro'

import { theme, fluidSystem, mediaM, mediaShort } from 'styled'

export const Root = styled.div`
  ${fluidSystem};
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  /* padding-top: 100px; */
  overflow: hidden;

  ${mediaShort`
    padding-top: 40px;
  `};

  /* &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: ${theme.presets.colors.mediumGrey};
    opacity: ${({ overlay }) => (overlay ? 0.65 : 0)};
    pointer-events: ${({ overlay }) => (overlay ? 'all' : 'none')};
    transition: opacity 0.3s;
  } */
`

export const Body = styled.div`
  position: relative;
  flex: 0 999 100%;
  width: 100%;
  /* height: 100%; */

  > .Inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
  }
`
export const Footer = styled.div`
  flex: 0 0 auto;
  width: 100%;
  height: 80px;
  background-color: ${theme.colors.lightGrey};
  display: flex;

  ${mediaShort`
    height: 60px;
  `};
`
const QuizColumn = styled.div`
  height: 100%;
  display: flex;
`
export const SideColumn = styled(QuizColumn)`
  flex: 1 0 400px;
  width: 100%;
  max-width: 25%;
  display: none;

  > * {
    max-width: 400px;
    width: 100%;
    height: 100%;
    padding-right: 8px;
  }

  ${mediaM`
    display: flex;
    `};
`
export const QuestionColumn = styled(QuizColumn)`
  ${fluidSystem};
  display: flex;
  justify-content: center;
  width: 100%;

  > * {
    max-width: 632px;
    width: 100%;
    height: 100%;
  }

  ${mediaM`
    flex: 0 1 650px;
    min-width: 50%;
  `};
`

export const GlossaryButton = styled.div`
  text-decoration: underline;
  text-transform: uppercase;

  &:hover {
    cursor: pointer;
  }
`

export const ModalWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
`
